export default __webpack_public_path__ + "static/media/Path.038c0495.svg";